import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import budgetDriversQueryKeys from './budgetDriversQueryKeys'
import { updateBudgetDriverOrders } from '../service/budgetDriversService'

export const useUpdateBudgetDriverOrders = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const queryClient = useQueryClient()

  if (!companyId) {
    throw new Error('Company ID is required for budget drivers.')
  }

  return useMutation({
    mutationKey: ['budget', 'budgetDriver', 'updateOrders'],
    mutationFn: (orders: Array<{ id: number; order: number }>) => updateBudgetDriverOrders(orders, companyId),
    onSuccess(updatedDrivers) {
      // Replace the entire list with the updated order from backend
      queryClient.setQueryData(budgetDriversQueryKeys.list({ companyId }), updatedDrivers)
    }
  })
}
